// Load Bootstrap JS
import 'bootstrap';

// Load Styles
import '../scss/index.scss';

document.addEventListener("DOMContentLoaded", (event) => {

});
